export default __webpack_public_path__ + "static/media/Coche - 11490.1406e145.mp4";